import { render, staticRenderFns } from "./EventRepeatsComponent.vue?vue&type=template&id=0bbd69af&scoped=true&"
import script from "./EventRepeatsComponent.vue?vue&type=script&lang=js&"
export * from "./EventRepeatsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd69af",
  null
  
)

export default component.exports